'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) Element.prototype.closest = function (s) {
  var el = this;
  if (!document.documentElement.contains(el)) return null;
  do {
    if (el.matches(s)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};

var getCommentReplyToElements = function getCommentReplyToElements() {
  return Array.prototype.slice.call(document.querySelectorAll('.comment-reply-to'));
};

var CommentListing = function () {
  function CommentListing() {
    _classCallCheck(this, CommentListing);

    this.oneQuarterOfASecondMS = 250;
    this.successRegexp = /[?|&]success=true/;

    this.replyingTo = '';
    this.skipAssociateContactReason = '';

    this.onFormReady = this.onFormReady.bind(this);
    this.onFormSubmitted = this.onFormSubmitted.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handlePostResponse = this.handlePostResponse.bind(this);
    this.scrollToComment = this.scrollToComment.bind(this);
    this.renderComment = this.renderComment.bind(this);
    this.hsPopulateCommentsFeed = this.hsPopulateCommentsFeed.bind(this);
    this.getExtraMetaDataBeforeSubmit = this.getExtraMetaDataBeforeSubmit.bind(this);
    this.setUpThreading = this.setUpThreading.bind(this);
  }

  _createClass(CommentListing, [{
    key: 'scrollToTarget',
    value: function scrollToTarget(scrollTargetLocator) {
      var _this = this;

      setTimeout(function () {
        var el = document.documentElement || document.body;
        var scrollTarget = document.querySelector(scrollTargetLocator);
        if (scrollTarget) {
          el.style.transition = 'all ' + _this.oneQuarterOfASecondMS;
          el.scrollTop = scrollTarget.offsetTop;
        }
      }, 0);
    }
  }, {
    key: 'getExtraMetaDataBeforeSubmit',
    value: function getExtraMetaDataBeforeSubmit() {
      return {
        skipAssociateContactReason: this.skipAssociateContactReason,
        replyingTo: this.replyingTo
      };
    }
  }, {
    key: 'onFormSubmitted',
    value: function onFormSubmitted() {
      var successParam = 'success=true';
      if (window.location.search) {
        if (this.successRegexp.exec(window.location.search)) {
          window.location.reload();
        } else {
          window.location.search += '&' + successParam;
        }
      } else {
        window.location.search = successParam;
      }
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(target, message) {
      var _this2 = this;

      var $dest = document.querySelector(target);
      if (!($dest && $dest.querySelector('form').length > 0)) {
        return setTimeout(function () {
          return _this2.handleSuccess(target, message);
        }, this.oneQuarterOfASecondMS);
      }

      $dest.insertAdjacentHTML('afterbegin', '<div class="hs-comment-message hs-common-confirm-message">' + message + '</div>');

      return this.scrollToTarget(target);
    }
  }, {
    key: 'handlePostResponse',
    value: function handlePostResponse(_ref) {
      var successMessage = _ref.successMessage,
          target = _ref.target;

      if (this.successRegexp.exec(window.location.search)) {
        this.handleSuccess(target, successMessage);
      }
    }
  }, {
    key: 'onFormReady',
    value: function onFormReady() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          successMessage = _ref2.successMessage,
          target = _ref2.target;

      return this.handlePostResponse({ successMessage: successMessage, target: target });
    }
  }, {
    key: 'isThreadId',
    value: function isThreadId(id) {
      var ids = id.split('.');

      for (var i = 0; i < ids.length; i++) {
        var part = ids[i];
        if (part.length !== 4 || parseInt(part, 10) < 0 || parseInt(part, 10) > 9999) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'scrollToComment',
    value: function scrollToComment(commentsSelector) {
      var hash = location.hash.replace('#', '');
      if (hash && this.isThreadId(hash)) {
        var hashTargetLocator = commentsSelector + ' [id=\'c' + hash + '\']';
        var $hashTarget = document.querySelector(hashTargetLocator);
        if ($hashTarget.length > 0) {
          this.scrollToTarget(hashTargetLocator);
        }
      }
    }
  }, {
    key: 'getDepth',
    value: function getDepth(id) {
      var ids = id.split('.');
      var depth = -1;

      for (var i = 0; i < ids.length; i++) {
        var part = ids[i];
        if (part === '0000') {
          return depth;
        }

        depth++;
      }

      return depth;
    }
  }, {
    key: 'setUpThreading',
    value: function setUpThreading(target) {
      var _this3 = this;

      var setReplyingTo = function setReplyingTo(replyingTo) {
        _this3.replyingTo = replyingTo;
      };
      getCommentReplyToElements().forEach(function (item) {
        item.addEventListener('click', function () {
          var $theComment = this.closest('.comment');
          if (!$theComment) {
            return;
          }
          setReplyingTo($theComment.dataset.threadid);

          var $formWrapper = document.querySelector(target);
          if (!$formWrapper) {
            return;
          }

          getCommentReplyToElements().forEach(function (resultItem) {
            resultItem.style.display = 'block';
          });

          var elReplyTo = $formWrapper.querySelector('input[name=replyingTo]');
          if (elReplyTo) {
            elReplyTo.style.display = 'none';
          }

          $formWrapper.style.display = 'none';

          $formWrapper.classList.add('replying');

          var replyingToText = 'Replying to ' + this.querySelector('em').innerHTML;
          var $replyingToEl = $formWrapper.querySelector('.replying-to');
          if ($replyingToEl) {
            $replyingToEl.innerText = replyingToText;
          } else {
            $formWrapper.insertAdjacentHTML('afterbegin', '<span class="replying-to">' + replyingToText + '</span>');
          }

          if ($theComment.parentNode) {
            $theComment.parentNode.insertBefore($formWrapper, $theComment.nextSibling);
          }

          $formWrapper.style.display = 'block';
          this.style.display = 'none';

          this.scrollToTarget(target);

          $formWrapper.querySelector('.hs_comment .hs-input').focus();
        });
      });
    }
  }, {
    key: 'highlightCode',
    value: function highlightCode(target) {
      var _window = window,
          hljs = _window.hljs;

      if (!(hljs && hljs.highlightBlock)) {
        return;
      }
      if (hljs.configure) {
        hljs.configure({ useBR: true });
      }
      var $target = document.querySelector(target);
      var codeElements = Array.prototype.slice.call($target.querySelectorAll('pre code'));
      codeElements.forEach(function (block) {
        return hljs.highlightBlock(block);
      });
    }
  }, {
    key: 'renderComment',
    value: function renderComment(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var commentText = data.commentText,
          created = data.created,
          threadId = data.threadInfo,
          user = data.user,
          userUri = data.userUri;
      var maxThreadDepth = options.maxThreadDepth,
          showForm = options.showForm;

      var depth = this.getDepth(threadId);
      var canReply = depth < maxThreadDepth && showForm;
      var comment = commentText.replace(/\n/g, '<br/>');
      var createdAt = new Date(created).toLocaleString();
      var html = '\n      <div id="c' + threadId + '" class="comment depth-' + depth + '" data-threadid="' + threadId + '">\n      <div class="comment-from">\n      <h4>\n      ';
      if (userUri) {
        var url = userUri.indexOf('http') !== 0 ? 'http://' + userUri : userUri;
        html += '<a href="' + url + '" rel="nofollow" target="_blank">' + user + '</a>';
      } else {
        html += user;
      }
      html += '\n      </h4>\n      </div>\n      <div class="comment-date">' + createdAt + '</div>\n      <div class="comment-body"><p>' + comment + '</p></div>\n      ';
      if (canReply) {
        html += '<button class="comment-reply-to hs-button secondary">Reply to <em>' + user + '</em></button>';
      }
      html += '</div>';
      return html;
    }
  }, {
    key: 'hsPopulateCommentsFeed',
    value: function hsPopulateCommentsFeed() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _Ajax2.default.jsonp(options.commentsUrl, function (data) {
        _this4.skipAssociateContactReason = options.skipAssociateContactReason;
        var commentsSelector = options.commentsSelector || '#comments-listing';
        var $commentListing = document.querySelector(commentsSelector);
        if (!$commentListing || $commentListing && $commentListing.querySelectorAll('.comment').length > 0) {
          return;
        }
        if (data.objects.length > 0) {
          $commentListing.setAttribute('data-has-comments', true);
        }
        var renderedComments = data.objects.map(function (comment) {
          return _this4.renderComment(comment, options);
        }).join('');

        $commentListing.insertAdjacentHTML('beforeend', renderedComments);
        _this4.setUpThreading('#' + options.target);
        _this4.highlightCode(commentsSelector);
        _this4.scrollToComment(commentsSelector);

        if (typeof hsPostCommentsComplete === 'function') {
          window.hsPostCommentsComplete($commentListing);
        }
      });
    }
  }]);

  return CommentListing;
}();

window.hsCommentListing = new CommentListing();
window.hsPopulateCommentsFeed = window.hsCommentListing.hsPopulateCommentsFeed;
window.hsPopulateCommentFormOnFormReady = window.hsCommentListing.onFormReady;
window.hsPopulateCommentFormOnFormSubmitted = window.hsCommentListing.onFormSubmitted;
window.hsPopulateCommentFormGetExtraMetaDataBeforeSubmit = window.hsCommentListing.getExtraMetaDataBeforeSubmit;


//////////////////
// WEBPACK FOOTER
// ./js/comment_listing_asset.js
// module id = 1
// module chunks = 3